var map = {
	"./task-call-completed.svg": 4242,
	"./task-call-pending.svg": 8392,
	"./task-completed.svg": 5375,
	"./task-email-completed.svg": 3826,
	"./task-email-pending.svg": 1994,
	"./task-meeting-completed.svg": 948,
	"./task-meeting-pending.svg": 8066,
	"./task-task-completed.svg": 2912,
	"./task-task-pending.svg": 445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9449;